import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {LoaderSubjectInf} from '../../../components/loader/loader.component';



@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  isLoading = new Subject<LoaderSubjectInf>();
  isMainContainerLoading = new BehaviorSubject<boolean>(false);
  isSidePanelLoading = new BehaviorSubject<boolean>(false);
  showCount: number;

  constructor() {
    this.showCount = 0;
  }

  show(customColor?: boolean): void {
    if (this.showCount === 0) {
      if (customColor) {
        this.isLoading.next({
          show: true,
          customColor: true
        });
      } else {
        this.isLoading.next({
          show: true,
          customColor: false
        });
      }
    }
    this.showCount++;

  }

  hide(): void {

    this.showCount--;
    if(this.showCount === 0) {
      this.isLoading.next({
        show: false
      });
    }

  }

  showMainContainer(): void {
      this.isMainContainerLoading.next(true);
  }

  hideMainContainer(): void {
    this.isMainContainerLoading.next(false);
  }

  showSidePanel(): void {
    this.isSidePanelLoading.next(true);
  }

  hideSidePanel(): void {
    this.isSidePanelLoading.next(false);
  }

}
